import { render, staticRenderFns } from "./trans-bets.vue?vue&type=template&id=88246e3a&scoped=true"
import script from "./trans-bets.vue?vue&type=script&lang=js"
export * from "./trans-bets.vue?vue&type=script&lang=js"
import style0 from "./trans-bets.vue?vue&type=style&index=0&id=88246e3a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88246e3a",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/bets/trans-bets.vue
// module id = V3pJ
// module chunks = 0